module.exports = __webpack_public_path__ + "static/media/consumindo-api-github.1cf54995.png";